export default {
  "menu.home": "Home",
  "menu.history": "History",
  "menu.deviceManagement": "Device",
  "menu.settings": "Settings",
  "menu.messageCenter": "Notice",
  "menu.help": "Help",
  "menu.mine": "Mine",
 };